import axios from 'axios';
import { api } from './configs';
import { SERVER_URL } from '../constants';

class Api {
  static url = SERVER_URL;

  /* Widget Start */

  static initWidget({ id }) {
    return api.get(`/widget/${id}/init `);
  }

  static getWidgetSlots({ id, ...body }) {
    return api.post(`/widget/${id}/get_time_slots `, body);
  }

  static makeWidgetBook({ id, ...body }) {
    return api.post(`/widget/${id}/create `, body);
  }

  static checkCaptcha({ token }) {
    return axios.get(`https://www.google.com/recaptcha/api/siteverify?secret=${process.env.REACT_APP_CAPTCHA_SECRET_KEY}&response=${token}`);
  }

  /* Widget End */
}

export default Api;
